import React, { FC, ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { Spin, Typography } from 'antd'
import { FlexRow, FlexColumn } from './FlexboxReusables/FlexItems'

type LoadingSpinnerProps = {
  loadingText?: string | ReactNode
  height?: string
}

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ loadingText, height }) => (
  <FlexRow height={height || '90vh'}>
    <FlexColumn>
      <Spin size='large' />
      <Typography.Text style={{ marginLeft: '1em' }}>
        {loadingText
          ? loadingText
          : <FormattedMessage description="loadingCourse" id="generic.loadingCourse" />
        }
      </Typography.Text>
    </FlexColumn>
  </FlexRow>
)

export default LoadingSpinner